console.log("init Proteus treatments -- 1.03")

document.addEventListener("proteus:cart-changed", async (e) => {
  console.log("proteus: cart updated", e.detail);
  window.cart_data = e.detail;
});

//
// START support for PP Offers
//

// support for proteus pp_offers
window.pp_active = true;
if(window.location.href.indexOf("qa=pp") > -1 || window.pp_active){
  window.sessionStorage.setItem("Proteus PP QA", true);
}

const push_pp_offers = () => {
  if(window.sessionStorage.getItem("Proteus pp-session-id") && window.cart_pp_offers.length > 0){

    // window.cart_pp_offers = [];
    if(window.location.href.indexOf("new_pp") > -1){
      window.cart_pp_offers = window.cart_pp_offers_new
    }

    let session_id = window.sessionStorage.getItem("Proteus pp-session-id");
    fetch("https://proteus-rawsugarliving.fly.dev/api/pp_offers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        referenceId: session_id,
        offers: window.cart_pp_offers
      })
    }).then(res => res.json()).then(console.log).catch(console.error);

  }
};

waitUntil(() => {
  return typeof window.cart_pp_offers != "undefined" && window.cart_pp_offers.length > 0;
}).then(() => {

  if(!window.sessionStorage.getItem("Proteus pp-session-id") && window.sessionStorage.getItem("Proteus PP QA")){
    let pp_session_id = "pp-";
    for (let i = 0; i < 16; i++) {
      pp_session_id += Math.floor(Math.random() * 10);
    }
    window.sessionStorage.setItem("Proteus pp-session-id", pp_session_id)
    setTimeout(() => {
      gtm_add_cartAttribute("pp-session-id", pp_session_id);
    }, 2500); // delay to reduce API clogging
  }

  push_pp_offers();

}).catch();

/*
// TODO: this call intercept works fine, maybe just make it a little less bloated
(function() {
  const originalFetch = window.fetch;

  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);

    const url = args[0];

    if (typeof url === "string" && url.includes("/cart/")) {
      response.clone().json().then(cart => {
        document.dispatchEvent(
          new CustomEvent("proteus:cart-changed", { detail: cart })
        );
      }).catch(() => {});
    }

    return response;
  };
})();

document.addEventListener("proteus:cart-changed", (e) => {
  console.log("Cart updated", e.detail);
});
*/

document.addEventListener("proteus:cart-changed", (e) => {
  // console.log("proteus: cart updated", e.detail);
  window.cart_data = e.detail;

  // The fetch hook dispatches this event with ANY /cart/* response body — including
  // error payloads (422s have no `items`) and empty carts. Guard both: the offers API
  // 500s on an empty `ids=` param, and `items` may be missing entirely.
  let cart_items = (e.detail && Array.isArray(e.detail.items)) ? e.detail.items : [];
  cart_items.sort(function(a, b) {
    return b.price - a.price;
  });

  let offers_max = cart_items.length;
  if(cart_items.length > 3){
    offers_max = 3;
  }

  let cart_prod_ids = [];
  for(let i = 0; i < offers_max; i++){
    if (cart_items[i].product_id) cart_prod_ids.push(cart_items[i].product_id);
  }
  if (cart_prod_ids.length === 0) return;

  get_proteus_product_data(cart_prod_ids.toString()).then(response => {
    console.log("get_proteus_product_data", response)
    window.staged_pp_offers = response.offers || [];
    
    window.cart_pp_offers = [];
    for(let i = 0; i < window.staged_pp_offers.length; i++){

      let discount_amount = window.staged_pp_offers[i].changes[0].discount.value;
      let discount_type = window.staged_pp_offers[i].changes[0].discount.valueType;

      let content_compare_at = window.staged_pp_offers[i].content_compare_at;
      let content_offer_price = window.staged_pp_offers[i].content_offer_price;

      if(window.staged_pp_offers[i].content_products.length > 0){
        
        content_compare_at = parseFloat(window.staged_pp_offers[i].content_products[0].variants.edges[0].node.price).toFixed(2);
        if (discount_type === "percentage") {
          content_offer_price = parseFloat(
            (content_compare_at * (1 - discount_amount / 100)).toFixed(2)
          );
        } else {
          content_offer_price = parseFloat(
            (content_compare_at - discount_amount).toFixed(2)
          );
        }

      }

      window.cart_pp_offers.push({

        pp_offer_type: window.staged_pp_offers[i].def_type,
        pp_offer_new_qty: window.staged_pp_offers[i].def_quantity,
        pp_offer_new_interval: window.staged_pp_offers[i].ref_new_interval,
        pp_offer_id: window.staged_pp_offers[i].def_offer_id,
        pp_offer_banner_title: window.staged_pp_offers[i].content_banner_title,
        pp_offer_banner_subtitle: window.staged_pp_offers[i].content_banner_subtitle,
        pp_offer_title: window.staged_pp_offers[i].content_title,
        pp_offer_image_url: window.staged_pp_offers[i].content_images[0],
        pp_offer_description: [window.staged_pp_offers[i].content_description],
        pp_offer_compare_at: content_compare_at,
        pp_offer_price: content_offer_price,
        changes: window.staged_pp_offers[i].changes,

      });

    }

    push_pp_offers();

  }).catch((err) => {
    console.warn("proteus: offers unavailable", err);
  })
});

async function get_proteus_product_data(prod_ids) {
  console.log("get_proteus_product_data()");
  // could potentially do this via Shopify REST API
  const response = await fetch(`https://proteus-rawsugarliving.fly.dev/api/catalog?lookup=product_offers&ids=${prod_ids}`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}

//
// END support for PP Offers
//

// start [RAW-12]

const incentives_data = [
  {
    threshold: 3500,
    label: "get <span>free shipping</span>",
  }
];

const max_message = "get free shipping"

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

const update_cart = () => {
  
  let cart_total = cart_data.total_price
  /*
  let cart_total = 0
  for(let i = 0; i < window.cart_data.items.length; i++){
    if(window.cart_data.items[i].properties["_category"] == "apparel" || 
    window.cart_data.items[i].properties["_category"] == "tights" || 
    window.cart_data.items[i].properties["_bundler_id"]){
      cart_total = cart_total + parseInt(window.cart_data.items[i].quantity);
    }
  }
  */

  waitForElement('.js-progressive-incentive').then(incentive => {

    let incentives_html = ``;
    let message_html = ``;
    for(let i = 0; i < incentives_data.length; i++){
      let threshold_met = cart_total >= incentives_data[i].threshold ? true : false;
      let previous_threshold = i > 0 ? incentives_data[i - 1].threshold : 0;
      let threshold_progress = parseInt(((cart_total - previous_threshold) / (incentives_data[i].threshold - previous_threshold))*100);
      
      incentives_html += `
        <div class="js-progressive-incentive--threshold" data-threshold="${incentives_data[i].threshold}" data-met="${threshold_met}" data-progress="${Math.max(0, Math.min(100, threshold_progress))}">
          <div class="js-progressive-incentive--fill-container">
            <div class="js-progressive-incentive--fill" style="width: 0%;"></div>
          </div>
          <div class="js-progressive-incentive--label">${incentives_data[i].label.replace("get ", "")}</div>
        </div>
      `;
      if(message_html == "" && !!cart_total){

        let met_message = ``;
        if(i-1 >= 0){
          met_message = `You ${incentives_data[i-1].label}!`;
        }

        const needed = incentives_data[i].threshold - cart_total;
        const pairText = needed === 1 ? 'pair' : 'pairs';
        const countText = needed === 1 ? 'one more' : `${needed} more`;

        if (!threshold_met) {
          // message_html = `${met_message} Add ${countText} ${pairText} to ${incentives_data[i].label}`;
          message_html = `${met_message} Add $${(needed/100).toFixed(2)} to ${incentives_data[i].label}`;
        } else if (threshold_met && i === incentives_data.length - 1) {
          message_html = `You ${max_message}`;
        }

      }
    }

    incentive.querySelector('.js-progressive-incentive--message').innerHTML = message_html;
    incentive.querySelector('.js-progressive-incentive--bar').innerHTML = incentives_html;

    // could be delayed to give an animation
    setTimeout(() => {
      let thresholds = document.querySelectorAll('.js-progressive-incentive--threshold');
      for(let i = 0; i < thresholds.length; i++){
        let threshold_progress = thresholds[i].getAttribute("data-progress");
        thresholds[i].querySelector('.js-progressive-incentive--fill').style.width = `${threshold_progress}%`;
      }
    }, 10)

  }).catch();
   
}

observeSelector('.cart-drawer__top', fs_bar => {
  
  if(document.querySelectorAll('.js-progressive-incentive').length == 0){
    // document.querySelector('.cart-drawer__line-items').insertAdjacentHTML("beforebegin", `
    fs_bar.insertAdjacentHTML("afterend", `
      <style>
      .Drawer__Container{
        max-height: calc(100vh - 300px) !important;
      }
      .js-progressive-incentive{
        margin-top: -2rem;
        padding: 1rem 1rem 2.5rem 1rem;
        border-color: #666;
        border-bottom: 1px solid #ddd;
      }

      @media(max-width: 768px){
        .js-progressive-incentive{
          font-size: .85rem;
        } 
      }

      .js-progressive-incentive--message{
        text-align: center;
        padding: .25rem 0;
      }
      .js-progressive-incentive--message span{
        
      }
      .js-progressive-incentive--bar{
        display: flex;
        border: 1px solid;
        border-radius: 10px;
      }

      .js-progressive-incentive--threshold{
        padding: 3px;
        position: relative;
        border-left: 1px solid;
        width: 100%;
      }
        
      .js-progressive-incentive--threshold:first-child{
        border-left: 0;
      }

      .js-progressive-incentive--threshold:first-child .js-progressive-incentive--fill-container,
      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--fill-container{
        border-radius: 10px 0 0 10px;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--fill-container{
        border-radius: 0 10px 10px 0;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .js-progressive-incentive--fill{
        background: #473729;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        max-width: 100%;
        min-width: 0;
        width: 0;
      }
      .js-progressive-incentive--label{
        position: absolute; 
        right: -50%;
        bottom: -1.5rem;
        width: 100%;
        text-align: center;
        display: none;
      }

      @media(max-width: 768px){
        .js-progressive-incentive--label{
          font-size: .75rem;
        }
      }

      .js-progressive-incentive--threshold:last-child .js-progressive-incentive--label{
        right: -.5rem;
        text-align: right;
      }

      .js-progressive-incentive--threshold:not([data-progress="100"], 
      [data-progress="0"]) .js-progressive-incentive--fill{
        /* transition: 1.5s ease; */
      }

      [data-progress="100"] .js-progressive-incentive--fill{
        width: 100% !important;
      }
      </style>
      <div class="js-progressive-incentive Cart__ShippingNotice Heading--bebas Text--center">
        <div class="js-progressive-incentive--message"></div>
        <div class="js-progressive-incentive--bar"></div>
      </div>
    `);
  }
 
  // init 
  update_cart();

  setTimeout(() => {
    update_cart(); 
  }, 2500);

});

let cached_item_count = cart_data.item_count;
setInterval(() => {
  
  if(cached_item_count !== cart_data.item_count){
    // console.log("compared, OOOOOOH changes");
    update_cart()
    cached_item_count = cart_data.item_count;
  } else {
    // console.log("compared, no changes");
  }
  
}, 1500)

// end [RAW-12]